/* eslint-disable no-unused-vars */
import { Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { blue, green, purple } from "@mui/material/colors";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PricingUtils } from "../../../utils/PricingUtils";
import PaymentCard from "./MPaymentCard";
import PaymentDigitPanel from "./MPaymentDigitPanel";
import PaymentItems from "./MPaymentItems";
import PaymentOptions from "./MPaymentOptions";
import { styled, createTheme } from "@mui/material/styles";
import { AgentUtils } from "../../../utils/AgentUtils";
import { withStyles } from "@mui/styles";
import { PoleDisplayUtils } from "../../../utils/PoleDisplayUtils";

const theme = createTheme({});
const PaymentButton = styled(Button)({
  width: "100%",
  fontSize: "1.28rem",

  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: green[500],
  "&:hover": {
    backgroundColor: green[700],
  },
});

const ActionButtonBlue = styled(Button)({
  width: "100%",
  fontSize: "10px",
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: blue[500],
  "&:hover": {
    backgroundColor: blue[700],
  },
});

export default function MPaymentWindow(props) {
  const { t } = useTranslation();
  const translate = t;
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [total, setTotal] = useState("");

  const [creditExpired, setCreditExpired] = useState(false);
  const [dueDateOver, SetDueDateOver] = useState(false);
  const [enableKeyListeners, setEnableKeyListeners] = useState(true);

  useEffect(() => {
    if (
      props.parentSaleBean &&
      props.parentSaleBean.className ==
        "com.saleolabs.retail.cloud.model.sale.SaleOrderBean"
    ) {
      let payment = [];
      let amount = 0;
      for (let payment of props.parentSaleBean.salePaymentBeanList) {
        amount = amount + parseFloat(payment.amount);
      }
      payment.push({
        code: "ADVANCE",
        value: translate("ADVANCE"),
        tendered: PricingUtils.formatPriceAfterRounding(
          amount,
          props.context.store.currencyDecimal
        ),
        amount: PricingUtils.formatPriceAfterRounding(
          amount,
          props.context.store.currencyDecimal
        ),
        balance: 0,
      });
      setPaymentData(payment);
    }

    if (
      props.saleType == "SALE_RETURN" &&
      props.parentSaleBean &&
      props.parentSaleBean.className ==
        "com.saleolabs.retail.cloud.model.sale.SaleBean"
    ) {
      let options = [...props.payCodeConfigs[props.saleType]];
      let isDisountExist = false;
      for (let opt of options) {
        if (opt.code === "DISCOUNT") {
          isDisountExist = true;
        }
      }
      if (
        isDisountExist &
        (parseFloat(props.parentSaleBean.subTotalDiscount) > 0)
      ) {
        let payment = [];

        payment.push({
          code: "DISCOUNT",
          value: translate("DISCOUNT"),
          tendered: 0,
          amount: props.parentSaleBean.subTotalDiscount,
          balance: 0,
        });
        setPaymentData(payment);
      }
    }
  }, [props.parentSaleBean]);

  useEffect(() => {
    let options = [...props.payCodeConfigs[props.saleType]];
    let newOpt = [];
    let isCredit = false;
    for (let opt of options) {
      if (opt.code === "CREDIT") {
        if (props.customerBean && props.customerBean.creditCustomer) {
          isCredit = true;
          newOpt.push(opt);
        }
      } else {
        newOpt.push(opt);
      }
    }
    if (isCredit) {
      for (let opt of options) {
        if (opt.code === "CREDIT") {
          opt.selected = true;
        } else {
          opt.selected = false;
        }
      }
    }
    setPaymentOptions(newOpt);

    let total = 0;
    for (let d of props.saleData) {
      total = total + parseFloat(d[8].v);
    }
    let tot = PricingUtils.formatPriceAfterRounding(
      total,
      props.context.store.currencyDecimal,
      props.saleSetting ? props.saleSetting.enableRoundoffSaleAmount : null,
      props.saleSetting ? props.saleSetting.roundOffFactor : null
    );
    setTotal(tot);
    if (
      props.customerBean &&
      props.customerBean.creditCustomer &&
      props.saleType == "SALE"
    )
      validatePayment(total);

    props.poleDisplayHandler(
      PoleDisplayUtils.prepareValue("", ""),
      PoleDisplayUtils.prepareValue(
        "Total:",
        PricingUtils.formattedNumber(tot, props.context.store.currencyDecimal)
      )
    );
  }, [props.saleData]);

  function validatePayment(total) {
    let payment = [];
    var res = props.customerBean.updateDate.split(" ");
    var lastPurchase = new Date(res[0]);

    const diffDays = Math.round(
      Math.abs((new Date() - lastPurchase) / (24 * 60 * 60 * 1000))
    );
    if (
      props.saleSetting.limitDaysOverride &&
      Number(props.customerBean.dueAmount) > 0 &&
      Number(diffDays) > Number(props.customerBean.limitDays)
    ) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Credit Payment Date Expired!"),
      });

      payment.push({
        code: "CREDIT",
        value: translate("CREDIT"),
        tendered: 0,
        amount: 0,
        balance: total,
      });
      setPaymentData(payment);
    } else if (
      props.saleSetting.creditLimitOverride &&
      Number(props.customerBean.dueAmount) + Number(total) >
        Number(props.customerBean.creditLimit)
    ) {
      let balance =
        Number(props.customerBean.dueAmount) +
        Number(total) -
        Number(props.customerBean.creditLimit);
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message:
          translate("Not enough credit, Balance to Pay") +
          ": " +
          String(balance) +
          props.context.store.currency,
      });
      payment.push({
        code: "CREDIT",
        value: translate("CREDIT"),
        tendered: props.customerBean.dueAmount,
        amount: props.customerBean.dueAmount,
        balance: Number(total) - Number(props.customerBean.dueAmount),
      });
      setPaymentData(payment);
    }
  }
  function dueDateCheck(today, lastDate) {
    var res = lastDate.split(" ");
    var lastPurchase = new Date(res[0]);
  }

  props.biRef.paymentWindow = {
    parentEvent: parentEvent,
  };

  function parentEvent(eventType, value) {
    if (eventType === "updatePayload") {
      updatePayload(value);
    } else if (eventType === "settled") {
      pRefs.paymentItem.parentEvent(eventType);
    } else if (eventType === "onKeyPressed") {
      handleKeyPress(value);
    }
  }

  function updatePayload(payload) {
    let payCodes = [];

    for (const row of paymentData) {
      let item = {};

      item["tenderedInActualCurr"] = row.tenderedInActualCurr;
      item["balanceWithCurrency"] = row.balanceWithCurrency;
      item["amountInActualCurr"] = row.amountInActualCurr;

      item["payCode"] = row.code;
      item["tendered"] = row.tendered;
      item["amount"] = row.amount;
      item["balance"] = row.balance ? row.balance : 0;
      item["isFx"] = row.isFxApplied ? true : false;
      item["amountInSourceCurrency"] = row.amountInSourceCurrency
        ? row.amountInSourceCurrency
        : row.amount;
      item["conversionRate"] = row.conversionRate ? row.conversionRate : 1;

      item["balanceInBaseCurrency"] = row.balanceInBaseCurrency
        ? row.balanceInBaseCurrency
        : 0;
      item["balanceInSourceCurrency"] = row.balanceInSourceCurrency
        ? row.balanceInSourceCurrency
        : 0;
      item["balanceCurrencyType"] = row.balanceCurrencyType
        ? row.balanceCurrencyType
        : "BASE";

      derviveFxReceived(item);

      payCodes.push(item);
    }
    payload["salePaymentBeanList"] = payCodes;
  }

  function derviveFxReceived(item) {
    if (item.isFx) {
      if (item.balanceCurrencyType === "BASE") {
        item["fxReceived"] = item["tendered"];
      } else {
        item["fxReceived"] = PricingUtils.formatPriceAfterRounding(
          parseFloat(item["tendered"]) -
            parseFloat(item["balanceInSourceCurrency"]),
          item["payCode"] === "OMR" ? 3 : props.context.store.currencyDecimal
        );
      }
    } else {
      item["fxReceived"] = "0.00";
    }
  }

  function handleKeyPress(event) {
    if (enableKeyListeners) {
      if (event.key === "escape") {
        props.showPaymentWindow(false);
      } else if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        pRefs.optionPanel.parentEvent(event.key);
      } else if ((event.key === "S" || event.key === "s") && event.ctrlKey) {
        if (pRefs.digitPanel.parentEvent("getEnableSaleSave")) {
          onKeyPressed(
            "Save",
            pRefs.digitPanel.parentEvent("getSetEnableSaleSaveFn")
          );
        }
      } else if (event.key === "F12") {
        if (pRefs.digitPanel.parentEvent("getEnableSaleSave")) {
          onKeyPressed(
            "Print",
            pRefs.digitPanel.parentEvent("getSetEnableSaleSaveFn")
          );
        }
      } else {
        pRefs.paymentCard.parentEvent("onKeyPressed", event.key);
      }
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function onKeyPressed(value, setEnableSaleSave, buttonIndex) {
    // console.log(value);
    if (value === "Save" || value === "Print") {
      pRefs.paymentItem.parentEvent(value, setEnableSaleSave, buttonIndex);
    } else {
      pRefs.paymentCard.parentEvent("onKeyPressed", value);
    }
  }

  function showPaymentCard() {
    pRefs.paymentItem.parentEvent("showPaymentCard");
  }

  function onProceedClicked() {
    let valid = true;
    let c = [];
    if (props.customFields && props.customFields.length > 0) {
      for (let cust of props.customFields) {
        if (cust.isRequired && cust.value === "") {
          cust["error"] = translate("Value required");
          valid = false;
        } else {
          cust["error"] = "";
        }
        c.push(cust);
      }
    }
    props.setCustomFields(c);
    if (valid) {
      props.setIsCustomFieldRequired(false);
    } else {
      props.setIsCustomFieldRequired(true);
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Custom field validation failed"),
      });
    }
  }

  function onClosePayment() {
    if (pRefs.paymentItem.parentEvent("isSettled")) {
      props.setSaleData([]);
      props.setRawSale([]);
      props.setCustomerId(null);
      props.setCustomerBean(null);
      props.resetCustomFields();
    }
    props.showWindow(false);
  }
  var pRefs = {};

  let mobileContent = (
    <div style={{ paddingBottom: "0px", marginTop: "5px" }}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h5" style={{ paddingLeft: 5 }}>
            {translate("Total")} : {total} {props.context.store.currency}
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <PaymentItems
            pRefs={pRefs}
            total={total}
            setAlert={props.setAlert}
            context={props.context}
            paymentOptions={paymentOptions}
            paymentData={paymentData}
            setPaymentData={setPaymentData}
            onSave={props.onSave}
            isMobile={true}
            saleType={props.saleType}
          ></PaymentItems>
        </Grid>
        <Grid item xs={4} style={{ marginTop: "2px" }}>
          <PaymentOptions
            paymentOptions={paymentOptions}
            customerBean={props.customerBean}
            setPaymentOptions={setPaymentOptions}
            pRefs={pRefs}
            context={props.context}
            isMobile={true}
          ></PaymentOptions>
        </Grid>
        <Grid
          item
          xs={8}
          sx={{
            height: AgentUtils.getWindowDimensionsExAppBars().h - 362,
            marginTop: "2px",
          }}
        >
          <PaymentCard
            paymentOptions={paymentOptions}
            paymentData={paymentData}
            setPaymentData={setPaymentData}
            total={total}
            context={props.context}
            pRefs={pRefs}
            isMobile={true}
            setAlert={props.setAlert}
            setEnableKeyListeners={setEnableKeyListeners}
            showPaymentCard={showPaymentCard}
            terminalBean={props.terminalBean}
            privileges={props.privileges}
          ></PaymentCard>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <PaymentDigitPanel
            pRefs={pRefs}
            onKeyPressed={onKeyPressed}
            saleSetting={props.saleSetting}
          ></PaymentDigitPanel>
        </Grid>
      </Grid>
    </div>
  );

  let desktopContent = (
    <div style={{ height: "532px" }} onKeyDown={handleKeyPress}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h4" style={{ paddingLeft: 10, paddingTop: 10 }}>
            {translate("Total")} : {total} {props.context.store.currency}
          </Typography>
        </Grid>
      </Grid>

      <Grid container style={{ padding: 10 }}>
        <Grid item xs={8}>
          <Grid container>
            <Grid item xs={12}>
              {/*<CustomerCard></CustomerCard>*/}
            </Grid>
            <Grid item xs={4}>
              <PaymentOptions
                paymentOptions={paymentOptions}
                customerBean={props.customerBean}
                setPaymentOptions={setPaymentOptions}
                pRefs={pRefs}
                context={props.context}
                isMobile={false}
              ></PaymentOptions>
            </Grid>
            <Grid item xs={8}>
              <PaymentCard
                paymentOptions={paymentOptions}
                paymentData={paymentData}
                setPaymentData={setPaymentData}
                total={total}
                context={props.context}
                pRefs={pRefs}
                isMobile={false}
                setAlert={props.setAlert}
                setEnableKeyListeners={setEnableKeyListeners}
                showPaymentCard={showPaymentCard}
                terminalBean={props.terminalBean}
                privileges={props.privileges}
                onKeyPressed={onKeyPressed}
              ></PaymentCard>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid container>
            <Grid item xs={12}>
              <PaymentItems
                pRefs={pRefs}
                total={total}
                setAlert={props.setAlert}
                context={props.context}
                paymentOptions={paymentOptions}
                paymentData={paymentData}
                setPaymentData={setPaymentData}
                onSave={props.onSave}
                isMobile={false}
                saleType={props.saleType}
              ></PaymentItems>
            </Grid>
            <Grid item xs={12}>
              <PaymentDigitPanel
                pRefs={pRefs}
                onKeyPressed={onKeyPressed}
                saleSetting={props.saleSetting}
              ></PaymentDigitPanel>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      {props.context.appMode === "mobile" ? mobileContent : desktopContent}
    </div>
  );
}
